const DocumentBoldIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.667 6.79398H11.7403C10.1603 6.79398 8.87366 5.50732 8.87366 3.92732V2.00065C8.87366 1.63398 8.57366 1.33398 8.20699 1.33398H5.38033C3.32699 1.33398 1.66699 2.66732 1.66699 5.04732V10.954C1.66699 13.334 3.32699 14.6673 5.38033 14.6673H10.6203C12.6737 14.6673 14.3337 13.334 14.3337 10.954V7.46065C14.3337 7.09398 14.0337 6.79398 13.667 6.79398Z"
      fill="currentColor"
    />
    <path
      d="M10.5338 1.47365C10.2604 1.20032 9.78711 1.38699 9.78711 1.76699V4.09365C9.78711 5.06699 10.6138 5.87365 11.6204 5.87365C12.2538 5.88032 13.1338 5.88032 13.8871 5.88032C14.2671 5.88032 14.4671 5.43365 14.2004 5.16699C13.2404 4.20032 11.5204 2.46032 10.5338 1.47365Z"
      fill="currentColor"
    />
  </svg>
);

export default DocumentBoldIcon;
